export const PORTCALLBUILDID = (window as any).PORTCALLBUILDID as string;


// WEBPACK FOOTER //
// ./apps/core/build.ts